import { db } from './firebase';
import {
  collection, addDoc, getDocs, getDoc, query,
  orderBy, limit, serverTimestamp, doc, setDoc
} from 'firebase/firestore';

// ── Identidad del club oficial ────────────────────────────────────────────────
export const CLUB_BOT = {
  id: 'leemos_oficial',
  nombre: 'Leemos',
  foto: null,
  esBot: true,
  badge: '📖 Oficial',
};

// ── Preguntas de bienvenida — se lanza una aleatoria al abrir la sala ─────────
const PREGUNTAS_INICIO = [
  "¡Bienvenidos a esta sala! ¿Quién ha empezado ya el libro? ¿Primeras impresiones?",
  "¡Sala abierta! ¿Cómo habéis llegado a este libro? ¿Recomendación, casualidad, o llevaba tiempo en vuestra lista?",
  "¡Empezamos! ¿Qué os hizo decidiros a leer este libro precisamente ahora?",
];

// ── Lanzar pregunta de bienvenida al abrir una sala ───────────────────────────
// Solo se lanza si la sala está completamente vacía (sin mensajes previos)
export async function animarSalaInactiva(salaId) {
  try {
    // Comprobar si ya hay mensajes en la sala
    const msgsSnap = await getDocs(
      query(
        collection(db, "salas", salaId, "mensajes"),
        limit(1)
      )
    );

    // Si ya hay mensajes no hacemos nada
    if (!msgsSnap.empty) return false;

    // Elegir pregunta aleatoria
    const pregunta = PREGUNTAS_INICIO[Math.floor(Math.random() * PREGUNTAS_INICIO.length)];

    // Enviar mensaje de bienvenida
    await addDoc(collection(db, "salas", salaId, "mensajes"), {
      texto: pregunta,
      spoiler: false,
      sender: CLUB_BOT,
      fecha: serverTimestamp(),
      esBot: true,
    });

    await setDoc(doc(db, "salas_info", salaId), { ultimaActividad: serverTimestamp() }, { merge: true }).catch(() => {});

    return true;
  } catch (e) {
    console.error("Error animando sala:", e);
    return false;
  }
}

// Exportamos esta función vacía para no romper imports existentes en App.js
export async function animarSalasInactivas() {}
